import { render, staticRenderFns } from "./BurstHeader.vue?vue&type=template&id=4c1e8978&scoped=true&"
import script from "./BurstHeader.vue?vue&type=script&lang=ts&"
export * from "./BurstHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BurstHeader.vue?vue&type=style&index=0&id=4c1e8978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e8978",
  null
  
)

export default component.exports